import { useState, useEffect } from 'react';
import Login from './Login.jsx';
import CreateElements from './CreateElements.jsx';
import AdminApiFetcher from './AdminApiFetcher.js';
import './admin.css';
const AdminApp = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentSection, setCurrentSection] = useState('waiting-points');
  const [currentData, setCurrentData] = useState([]);
  const [block, setBlock] = useState(false);
  const apiFetcher = new AdminApiFetcher();
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const [currentEvents, setCurrentEvents] = useState(``);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [disabled, setDisabled] = useState(false)
  const [userPointData, setUserPointData] = useState({
    id: ``,
    points: 0
  });

  const [userPointRemove, setUserPointRemove] = useState({
    id: ``,
    points: 0
  })
  const [adminData, setAdminData] = useState({
    username: '',
    name: '',
    surname: '',
    password: '',
    repeatPass: ''
  })

  const [userData, setUserData] = useState({
    name: '',
    surname: '',
    email: ``,
    telephoneNumber: ``,
    points: 0,
    password: '',
    repeatPass: ''
  })


  const handlePointAdd = async () => {
    if(!userPointData.id.length > 0 && !userPointData.points.length > 0) {
      alert(`Wypełnij wszystkie pola`)
      return;
    }
    setDisabled(true)
    const pointAdded = await apiFetcher.addPoints(userPointData.id, userPointData.points);
    if(!pointAdded) {
      alert(`Wystąpił błąd, upewnij się że ID jest poprawne`);
      setDisabled(false);
      return
    }

    alert(`Dodano ${userPointData.points} punktów`)
    setDisabled(false);

  }

  const handlePointRemove = async () => {
    if(!userPointRemove.id.length > 0 && !userPointRemove.points.length > 0) {
      alert(`Wypełnij wszystkie pola`)
      
      return;
    }
    setDisabled(true)
    const isDeleted= await apiFetcher.deletePoinst(userPointRemove.id, userPointRemove.points);
    if(!isDeleted) {
      alert(`ID niepoprawne lub użytkownik ma za mało punktów`);
      setDisabled(false);
      return
    }

    alert(`Odebrano ${userPointRemove.points} punktów`)
    setDisabled(false);

  }

  const nextMonth = () => {
    if(block) return
    const today = new Date();
    const isCurrentMonth = today.getMonth() === month && today.getFullYear() === year;
    if(currentEvents === `archive` && isCurrentMonth) {
      return
    }
    setBlock(true)
    setMonth((prev) => {
      const newMonth = prev === 11 ? 0 : prev + 1;
      if (prev === 11) {
        setYear(year + 1);
      }
      return newMonth;
    });
    setBlock(false);


  };

  const prevMonth = () => {
    if(block) return
    const today = new Date();
    const isCurrentMonth = today.getMonth() === month && today.getFullYear() === year;
    if(currentEvents === `active` && isCurrentMonth) {
      return
    }
    setBlock(true)
    setMonth((prev) => {
      const newMonth = prev === 0 ? 11 : prev - 1;
      if (prev === 0) {
        setYear(year - 1);
      }
      return newMonth;
    });

    setBlock(false);

  };

  const showErrors = (errors) => {
    let errorMessage = `Wystąpiły następujące błędy:`;
    errors.forEach((error) => {
      errorMessage += `\n ${error}`
    })
    alert(errorMessage)
  }

  const validateUserData = () => {
    const errors = []
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
        errors.push(`Nieprawidłowy e-mail`);
      };
    if(!userData.name || !userData.name.length > 1) {
      errors.push(`Niepoprawne imię`);
    };

    if(!userData.telephoneNumber || !userData.telephoneNumber.length > 1) {
      errors.push(`Niepoprawny numer telefonu`);
    };

    if(!userData.surname || !userData.surname.length > 1) {
      errors.push(`Niepoprawne nazwisko`)
    };

    if(userData.password !== userData.repeatPass || userData.password.length < 8) {
      
      errors.push(`Hasła się nie zgadzają lub są za krótkie`)
    };
    if(errors.length > 0) {
      showErrors(errors)
      return false
    };

    return true

  }

  const validateAdminData = () => {
    const errors = []
    if(!adminData.username || !adminData.username.length > 3) {
        errors.push(`Nazwa użytkownika musi zawierać minimum 3 znaki`)
      }
    if(!adminData.name || !adminData.name.length > 1) {
      errors.push(`Niepoprawne imię`)
    }

    if(!adminData.surname || !adminData.surname.length > 1) {
      errors.push(`Niepoprawne nazwisko`)
    }

    if(adminData.password !== adminData.repeatPass || adminData.password.length < 8) {
      errors.push(`Hasła się nie zgadzają lub są za krótkie`)
    }
    if(errors.length > 0) {
      showErrors(errors)
      return false
    }

    return true

  }

 
  const handleCreate = async (e) => {
    const {id} = e.target;

    const createAdmin = async () => {
      const isCreated = await apiFetcher.createAdmin(adminData);
      if(isCreated) {
        alert(`Utworzono konto administatora`)
      }else {
        alert(`Bląd przy tworzeniu konta`)
      }
    }

    const createUser = async () => {
      const user = await apiFetcher.createUser(userData);
      if(user.confirmed && !user.error) {
        alert(`Utworzono konto użytkownika`)
      }else {
        alert(`Bląd przy tworzeniu konta`)
      }
    }
  
    switch(id) {
      case `create-admin`:
        if(!validateAdminData()) return;
        createAdmin();
      ; break;

      case `create-user`: 
      if(!validateUserData()) return;
      createUser()
      ; break;
    }
  }

  const handleInputChange =(e, inputData) => {
    const {id, value} = e.target
    const setData = inputData[1];
    const data = inputData[0];
    setData({...data, [id]: value})
  }

  const waitingPointsHead = ['Imię', 'Nazwisko', 'ID', 'Oczekujące punkty', 'Dodaj punkty', 'Rezygnacja'];
  const allUsersHead = ['ID', 'Imię', 'Nazwisko', 'Kod polecenia', 'Punkty'];
  const activeReservationHead = ['Imię i nazwisko', 'ID użytkownika', 'ID rezerwacji', 'Miejscowość', 'Data', 'Odwołaj'];
  const archiveReservationHead = ['Imię i nazwisko', 'ID użytkownika', 'ID rezerwacji', 'Miejscowość', 'Data', 'Usuń'];
  const unrealizedArchiveHead = ['Imię i nazwisko', 'ID użytkownika', 'ID rezerwacji', 'Miejscowość', 'Data', 'Przywróć'];
  const adminHead = ['Imie', 'Nazwisko', 'Nazwa użytkownika', 'Usuń konto'];

  const sortKeys = {
    'waiting-points': ['name', 'surname', '_id'],
    'users': ['name', 'surname', 'referralCode', 'points'],
    'events': ['name', 'location', 'date'],
    'archive-events': ['name', 'location', 'date'],
    'unrealized-archive': ['name', 'location', 'date'],
    'administrators': ['name', 'surname', 'username'],
  };

  useEffect(() => {
    const checkToken = async () => {
      const token = localStorage.getItem(`adminJwt`);
      if(!token) return;
      const response = await apiFetcher.authenticateToken();
      if (response) {
        setIsAuthenticated(true);
        waitingPoints();
      }
    };
    checkToken();
  }, []);


  useEffect(() => {
    if(currentSection === `users`) {
      getAllUsers();
    }else if(currentSection === `administrators`) {
      adminManagement();
    }
  },[page])

  const unlockPanel = () => setIsAuthenticated(true);


  const waitingPoints = async () => {
    const data = await apiFetcher.getAwaitingUsers();
    if (data) {
      setCurrentSection('waiting-points');
      setCurrentData(data);
      setBlock(false);
    }
  };


  const getAllUsers = async () => {
    const {users,pages,total} = await apiFetcher.getAllUsers(page);
    if (users) {
      setTotalPages(total);
      setCurrentSection('users');
      setCurrentData(users);
      console.log(users);
      setBlock(false);
    }
  };



  const getAllEvents = async (type) => {
    setCurrentEvents(type);
    const currentDate = new Date(year,month)
    const data = await apiFetcher.getAllEvents(type, currentDate);
    let events
    if (data) {
      events = data.response;
    }
    setCurrentSection(type === 'active' ? 'events' : 'archive-events');
    setCurrentData(events || []);
    setBlock(false);
  };


  const getUnrealizedEvents = async () => {
    setCurrentEvents(`unrealized-archive`);
    const currentDate = new Date(year,month)
    const events = await apiFetcher.getUnrealizedEvents(currentDate);
    
    setCurrentSection('unrealized-archive');
    setCurrentData(events || []);
    setBlock(false);
  };

  const adminManagement = async () => {
    const {users,pages,total} = await apiFetcher.getAdmins(page);
    if (users) {
      setTotalPages(total)
      setCurrentSection('administrators');
      setCurrentData(users);
    }
    setBlock(false);
  };

  const handleNavigation = (section) => {
    if (block) return;
    setBlock(true);
    switch (section) {
      case 'waiting-points': waitingPoints(); break;
      case 'users': getAllUsers(); break;
      case 'active-reservation': getAllEvents('active'); break;
      case 'archive': getAllEvents('archive'); break;
      case 'unrealized-archive': getUnrealizedEvents(); break;
      case 'administators': adminManagement(); break;
      default: waitingPoints(); break;
    }
  };

  const getCurrentHead = () => {
    switch (currentSection) {
      case 'waiting-points': return waitingPointsHead;
      case 'users': return allUsersHead;
      case 'events': return activeReservationHead;
      case 'archive-events': return archiveReservationHead;
      case 'unrealized-archive': return unrealizedArchiveHead;
      case 'administrators': return adminHead;
      default: return waitingPointsHead;
    }
  };


  useEffect(() => {
    if(
      currentSection === `events` || 
      currentSection === `archive-events`
      ) {
        getAllEvents(currentEvents);
    }else if(currentSection === `unrealized-archive`) {
      getUnrealizedEvents();
    }
  },[month])


  return (
    <div className='admin-panel'>
      <header className="desktop-header">
        <div className="header-text-container">
          <h2 id="initials">PC</h2>
        </div>
      </header>
      {!isAuthenticated ? (
        <Login apiFetcher={apiFetcher} onLoginSuccess={unlockPanel} />
      ) : (
        <div id="grid-container" style={{ display: 'grid' }}>
          <div id="nav-bar">
            <h2 id="waiting-points" onClick={() => handleNavigation('waiting-points')} style={{ color: currentSection === 'waiting-points' ? 'black' : 'gray' }}>
              Oczekujące punkty
            </h2>
            <h2 id="users" onClick={() => handleNavigation('users')} style={{ color: currentSection === 'users' ? 'black' : 'gray' }}>
              Użytkownicy
            </h2>
            <h2 id="active-reservation" onClick={() => handleNavigation('active-reservation')} style={{ color: currentSection === 'events' ? 'black' : 'gray' }}>
              Nadchodzące rezerwacje
            </h2>
            <h2 id="unrealized-archive" onClick={() => handleNavigation('unrealized-archive')} style={{ color: currentSection === 'unrealized-archive' ? 'black' : 'gray' }}>
              Archiwum niezrealizowanych
            </h2>
            <h2 id="archive" onClick={() => handleNavigation('archive')} style={{ color: currentSection === 'archive-events' ? 'black' : 'gray' }}>
              Archiwum rezerwacji
            </h2>
            <h2 id="administators" onClick={() => handleNavigation('administators')} style={{ color: currentSection === 'administrators' ? 'black' : 'gray' }}>
              Administratorzy
            </h2>
          </div>
          <div id="info-container">

            <div id="user-container" className="create-container" style={{ display: currentSection === 'users' ? 'flex' : 'none' }}>
              <p>Utwórz konto użytkownika</p>
              <input onChange={(e) => {handleInputChange(e,[userData, setUserData])}} id='name' placeholder="Imię" type="text" />
              <input onChange={(e) => {handleInputChange(e,[userData, setUserData])}} id='surname' placeholder="Nazwisko" type="text" />
              <input onChange={(e) => {handleInputChange(e,[userData, setUserData])}} id='email' placeholder="E-mail" type="text" />
              <input onChange={(e) => {handleInputChange(e,[userData, setUserData])}} id='telephoneNumber' placeholder="Numer telefonu" type="text" />
              <input onChange={(e) => {handleInputChange(e,[userData, setUserData])}} id='points' placeholder="Punkty na start (opcjonalne)" type="number" min={0} />
              <input onChange={(e) => {handleInputChange(e,[userData, setUserData])}} id='password' placeholder="Hasło" type="text" />
              <input onChange={(e) => {handleInputChange(e,[userData, setUserData])}} id='repeatPass' placeholder="Powtórz hasło" type="text" />
              <button onClick={handleCreate} type="button" id="create-user">Potwierdź</button>
  
              <p>UWAGA! Zapisz hasło w bezpiecznym miejscu. Nie można go potem zobaczyć</p>
              <div className='points-edit-container'>
                <div className='points-input-container'>
                <p>Dodaj punkty</p>
                  <input id='id' onChange={(e) => {handleInputChange(e,[userPointData, setUserPointData])}} placeholder='ID użytkownika'></input>
                  <input id='points' onChange={(e) => {handleInputChange(e,[userPointData, setUserPointData])}} type='number' min={0} placeholder='Ilość punktów'></input>
                  <button disabled={disabled} onClick={handlePointAdd} type="button">Potwierdź</button>
                </div>

                <div className='points-input-container'>
                  <p>Odbierz punkty</p>
                  <input id='id' onChange={(e) => {handleInputChange(e,[userPointRemove, setUserPointRemove])}} placeholder='ID użytkownika'></input>
                  <input id='points' onChange={(e) => {handleInputChange(e,[userPointRemove, setUserPointRemove])}} type='number' min={0} placeholder='Ilość punktów'></input>
                  <button disabled={disabled} onClick={handlePointRemove}  type="button">Potwierdź</button>
                </div>
              </div>
        

              <h3>Użytkownicy</h3>
            </div>
            <div id="admin-container" className="create-container" style={{ display: currentSection === 'administrators' ? 'flex' : 'none' }}>
              <p>Utwórz konto administatora</p>

              <input onChange={(e) => {handleInputChange(e,[adminData, setAdminData])}} id="name" placeholder="Imię" type="text" />
              <input onChange={(e) => {handleInputChange(e,[adminData, setAdminData])}} id="surname" placeholder="Nazwisko" type="text" />
              <input onChange={(e) => {handleInputChange(e,[adminData, setAdminData])}} id="username" placeholder="Nazwa użytkownika" type="text" />
              <input onChange={(e) => {handleInputChange(e,[adminData, setAdminData])}} id='password' placeholder="Hasło (Minimum 8 znaków)" />
              <input onChange={(e) => {handleInputChange(e,[adminData, setAdminData])}} id="repeatPass" placeholder="Powtórz hasło"/>
              <button onClick={handleCreate} type="button" id="create-admin">Potwierdź</button>
              <p>UWAGA! Zapisz hasło w bezpiecznym miejscu. Nie można go potem zobaczyć</p>
    

              <h3>Administratorzy</h3>
            </div>
            <CreateElements
              page={page}
              setPage={setPage}
              totalPages={totalPages}
              apiFetcher={apiFetcher}
              currentSection={currentSection}
              currentData={currentData}
              head={getCurrentHead()}
              sortKeys={sortKeys}
              nextMonth={nextMonth}
              prevMonth={prevMonth}
              month={month}
              year={year}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminApp;